import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=3c92aa09&scoped=true&"
import script from "./TheLogo.vue?vue&type=script&lang=js&"
export * from "./TheLogo.vue?vue&type=script&lang=js&"
import style0 from "./TheLogo.vue?vue&type=style&index=0&id=3c92aa09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92aa09",
  null
  
)

export default component.exports